import { AlignLeft, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { HighlightComponentProps } from "../highlights";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { remarkCitations } from "@/components/assistant-ui/citation";
import { defaultComponents } from "@/components/assistant-ui/markdown-text";

export const SummaryPreview: React.FC<HighlightComponentProps> = ({
  result,
  isExpanded = false,
  onToggleExpand,
}) => {
  const { contents } = result;
  const summary = contents.summary as string;

  return (
    <div className="space-y-2">
      <div className="rounded-lg border border-theme bg-theme-1 px-3 py-2.5 hover:border-theme transition-colors">
        <div className="flex items-start gap-2.5">
          {/* Icon badge */}
          <div className="mt-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-slate-700 text-white flex-shrink-0">
            <AlignLeft className="h-3 w-3" />
          </div>

          <div className="flex-1 min-w-0">
            {/* Summary text */}
            <p
              className={cn(
                "text-[12px] leading-relaxed text-theme-0 transition-all",
                !isExpanded && "line-clamp-4"
              )}
            >
              <ReactMarkdown
                remarkPlugins={[remarkGfm, remarkCitations]}
                components={defaultComponents}
              >
                {summary}
              </ReactMarkdown>
            </p>
          </div>
        </div>

        {/* Hint row */}
        <div className="mt-2 pt-2 border-t border-theme flex items-center gap-1.5 text-[10px] text-theme-1 font-medium">
          <AlignLeft className="h-3 w-3 text-indigo-500" />
          Key concepts distilled into a concise summary
        </div>
      </div>

      {/* Expand affordance */}
      {summary?.length > 0 && (
        <button
          onClick={onToggleExpand}
          className="w-full flex items-center justify-center gap-1.5 py-2 text-[11px] font-semibold text-theme-2 hover:text-theme-0 transition-colors rounded-lg hover:bg-theme-1"
        >
          <span>{isExpanded ? "Show less" : "Read full summary"}</span>
          {!isExpanded && <ChevronDown className="h-3.5 w-3.5" />}
        </button>
      )}
    </div>
  );
};
